import api from "../../api/axios.config"
import { getUserDetails } from "./authThunk";

export const postSaveMySize = (DataSize, userId) => {
    return async (dispatch, getState) => {
      const result = await api.put(`/api/users/${userId}`, DataSize);
      dispatch(getUserDetails());
    }
  }